import { render, staticRenderFns } from "./PurchasedKits.vue?vue&type=template&id=105bfa26&"
import script from "./PurchasedKits.vue?vue&type=script&lang=js&"
export * from "./PurchasedKits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports